module.exports = __webpack_public_path__ + "static/media/londre-swimsuits-back.f5c4ece1.jpg";